var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFovime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 217.3 217.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 108.65,
    cy: 108.65,
    r: 108.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "125.5 47.83 125.5 52.33 108.65 39.9 81.71 59.78 81.71 74.44 91.8 74.44 91.8 64.88 108.65 52.45 125.5 64.88 125.5 74.44 135.59 74.44 135.59 47.83 125.5 47.83",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.65,106.86c-14.74,0-26.73-11.99-26.73-26.73h10.1c.39,21.87,32.89,21.85,33.27,0h10.1c0,14.74-11.99,26.73-26.73,26.73h0Z",
    style: {
      fill: "#00bc70"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "38.87 146.35 42.84 146.35 42.84 133.66 56.46 133.66 56.46 129.91 42.84 129.91 42.84 121.95 56.88 121.95 56.88 118.08 38.87 118.08 38.87 146.35",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.26 141.6 89.89 118.08 85.63 118.08 95.97 146.35 100.56 146.35 110.9 118.08 106.66 118.08 98.26 141.6",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.5,
    y: 118.08,
    width: 4.01,
    height: 28.27,
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.94 141.54 128.93 118.08 123.14 118.08 123.14 146.35 127.12 146.35 127.12 123.75 135.72 146.35 140.11 146.35 148.72 123.75 148.72 146.35 152.69 146.35 152.69 118.08 146.87 118.08 137.94 141.54",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.43 121.95 178.43 118.08 158.32 118.08 158.32 146.35 178.43 146.35 178.43 142.52 162.3 142.52 162.3 133.66 177.98 133.66 177.98 129.91 162.3 129.91 162.3 121.95 178.43 121.95",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.42,118.08c-6.41,0-15.55-1.4-15.96,7.68.53,6.7-2.91,20.36,7.68,20.59,6.41,0,15.55,1.4,15.96-7.68-.53-6.7,2.91-20.36-7.68-20.59Zm0,24.4h-8.29c-2.1,0-3.81-1.71-3.81-3.81v-12.92c0-2.1,1.71-3.81,3.81-3.81h8.29c2.1,0,3.81,1.71,3.81,3.81v12.92c0,2.1-1.71,3.81-3.81,3.81Z",
    style: {
      fill: "#004876"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39.29,159.34v-5.19h2.24v.5h-1.72v1.81h1.58v.5h-1.58v2.38h-.51Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.49,154.08c.47,0,.82.14,1.03.41s.32.72.32,1.35v1.8c0,.62-.11,1.07-.32,1.34s-.55.41-1.03.41h-.45c-.48,0-.82-.14-1.03-.41s-.32-.72-.32-1.34v-1.8c0-.62.11-1.07.32-1.35.21-.28.55-.41,1.03-.41h.45Zm-.07.51h-.32c-.33,0-.55.08-.68.25-.12.17-.18.5-.18,1v1.8c0,.5.06.83.18.99s.35.25.68.25h.32c.33,0,.55-.08.68-.25.12-.17.18-.5.18-.99v-1.8c0-.5-.06-.83-.18-1-.12-.17-.35-.25-.68-.25Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.36,159.34v-5.19h.76l1.93,4.61v-4.61h.5v5.19h-.79l-1.9-4.53v4.53h-.5Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.12,159.34v-5.19h1.3c.67,0,1.14.14,1.4.41.26.28.4.77.4,1.47v1.43c0,.71-.13,1.2-.4,1.47s-.73.41-1.4.41h-1.3Zm.51-.48h.69c.3,0,.54-.02.71-.07s.3-.12.4-.23c.09-.11.15-.24.19-.39s.05-.4.05-.73v-1.4c0-.33-.02-.57-.05-.73-.04-.16-.1-.28-.19-.39-.09-.1-.23-.18-.4-.23-.17-.05-.41-.07-.71-.07h-.69v4.24h0Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.49,154.08c.47,0,.82.14,1.03.41s.32.72.32,1.35v1.8c0,.62-.11,1.07-.32,1.34s-.55.41-1.03.41h-.45c-.48,0-.82-.14-1.03-.41-.21-.27-.32-.72-.32-1.34v-1.8c0-.62.11-1.07.32-1.35.21-.28.55-.41,1.03-.41h.45Zm-.07.51h-.32c-.33,0-.55.08-.68.25-.12.17-.18.5-.18,1v1.8c0,.5.06.83.18.99.12.17.35.25.68.25h.32c.33,0,.55-.08.68-.25.12-.17.18-.5.18-.99v-1.8c0-.5-.06-.83-.18-1-.12-.17-.35-.25-.68-.25Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.87,159.34v-5.19h1.3c.67,0,1.14.14,1.4.41.26.28.4.77.4,1.47v1.43c0,.71-.13,1.2-.4,1.47s-.73.41-1.4.41h-1.3Zm.51-.48h.69c.3,0,.54-.02.71-.07s.3-.12.4-.23c.09-.11.15-.24.19-.39s.05-.4.05-.73v-1.4c0-.33-.02-.57-.05-.73-.04-.16-.1-.28-.19-.39-.09-.1-.23-.18-.4-.23-.17-.05-.41-.07-.71-.07h-.69v4.24h0Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m70.82,158.84v.5h-2.32v-5.19h2.32v.5h-1.81v1.74h1.68v.5h-1.68v1.95h1.81Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.58,159.34l-1.31-5.19h.55l1.07,4.5,1.18-4.5h.52l-1.41,5.19h-.6Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.79,159.34v-5.19h.51v5.19h-.51Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.83,159.34l-1.31-5.19h.55l1.07,4.5,1.18-4.5h.52l-1.41,5.19h-.6Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.04,159.34v-5.19h.51v5.19h-.51Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.47,158.84v.5h-2.32v-5.19h2.32v.5h-1.81v1.74h1.68v.5h-1.68v1.95h1.81Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.8,159.34v-5.19h.76l1.93,4.61v-4.61h.5v5.19h-.79l-1.9-4.53v4.53h-.5Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.57,159.34v-5.19h1.3c.67,0,1.14.14,1.4.41.26.28.4.77.4,1.47v1.43c0,.71-.13,1.2-.4,1.47s-.73.41-1.4.41h-1.3Zm.51-.48h.69c.3,0,.54-.02.71-.07s.3-.12.4-.23c.09-.11.15-.24.19-.39s.05-.4.05-.73v-1.4c0-.33-.02-.57-.05-.73-.04-.16-.1-.28-.19-.39-.09-.1-.22-.18-.4-.23s-.41-.07-.71-.07h-.69v4.24h0Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.76,159.34l1.49-5.19h.6l1.4,5.19h-.56l-.29-1.12h-1.8l-.32,1.12h-.51,0Zm.97-1.6h1.54l-.74-2.89-.8,2.89Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.9,159.34v-5.19h.82l1.45,4.57,1.56-4.57h.79v5.19h-.47v-4.75l-1.61,4.75h-.53l-1.53-4.75v4.75h-.47Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.1,159.34v-5.19h.51v5.19h-.51Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m115.21,159.34v-5.19h.51v4.69h1.54v.51h-2.06Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m118.4,159.34v-5.19h.51v5.19h-.51Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.24,159.34v-4.68h-1.11v-.5h2.74v.5h-1.11v4.68h-.51Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m123.31,159.34l1.49-5.19h.6l1.4,5.19h-.56l-.29-1.12h-1.8l-.32,1.12h-.51,0Zm.97-1.6h1.54l-.74-2.89-.8,2.89h0Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.45,157.26v2.07h-.51v-5.19h1.46c.6,0,1,.09,1.19.27.2.18.29.52.29,1.02v.48c0,.33-.07.59-.2.76-.13.17-.33.28-.61.31.26.05.45.16.57.34s.18.42.18.74v1.28h-.51v-1.04c0-.41-.07-.69-.2-.82s-.39-.21-.77-.21h-.89Zm.87-2.64h-.87v2.14h.87c.43,0,.7-.05.82-.17s.18-.32.18-.64v-.67c0-.26-.06-.43-.17-.52s-.39-.14-.83-.14Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.88,159.34v-5.19h1.3c.67,0,1.14.14,1.4.41s.4.77.4,1.47v1.43c0,.71-.13,1.2-.4,1.47s-.73.41-1.4.41h-1.3Zm.51-.48h.69c.3,0,.54-.02.71-.07s.3-.12.4-.23c.09-.11.15-.24.19-.39.04-.15.05-.4.05-.73v-1.4c0-.33-.02-.57-.05-.73-.04-.16-.1-.28-.19-.39-.09-.1-.22-.18-.4-.23s-.41-.07-.71-.07h-.69v4.24h0Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m141.83,158.84v.5h-2.32v-5.19h2.32v.5h-1.81v1.74h1.68v.5h-1.68v1.95h1.81Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m143.16,159.34v-5.19h.51v4.69h1.54v.51h-2.06Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.16,158.84v.5h-2.32v-5.19h2.32v.5h-1.81v1.74h1.68v.5h-1.68v1.95h1.81Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m154.69,154.14v4.05c0,.46-.09.78-.28.95s-.51.26-.99.26-.81-.09-.99-.26c-.18-.17-.27-.49-.27-.95v-.6h.51v.41c0,.36.05.61.16.73s.3.18.59.18.49-.06.6-.19.16-.37.16-.73v-3.85h.52Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m158.57,158.84v.5h-2.32v-5.19h2.32v.5h-1.81v1.74h1.68v.5h-1.68v1.95h1.81Zm-1.64-5.14l.73-1.23h.62l-.98,1.23h-.37Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.42,157.26v2.07h-.51v-5.19h1.46c.6,0,1,.09,1.19.27.2.18.29.52.29,1.02v.48c0,.33-.07.59-.2.76-.13.17-.33.28-.61.31.26.05.45.16.57.34s.18.42.18.74v1.28h-.51v-1.04c0-.41-.07-.69-.2-.82s-.39-.21-.77-.21h-.89Zm.87-2.64h-.87v2.14h.87c.43,0,.7-.05.82-.17s.18-.32.18-.64v-.67c0-.26-.06-.43-.17-.52s-.39-.14-.83-.14Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m167.21,157.59s0,.07,0,.12v.19c0,.51-.1.89-.3,1.14-.2.24-.51.37-.92.37h-.5c-.22,0-.42-.04-.59-.12s-.3-.19-.4-.33c-.08-.12-.14-.27-.17-.43s-.05-.41-.05-.75v-1.92c0-.62.11-1.07.32-1.35.21-.28.55-.41,1.03-.41h.27c.47,0,.81.11,1.01.35.2.23.3.62.3,1.15v.15s0,.07,0,.09h-.55v-.06c0-.45-.05-.76-.17-.92-.11-.16-.31-.24-.61-.24h-.28c-.3,0-.5.08-.61.25-.11.17-.17.5-.17,1v1.74c0,.58.05.95.15,1.09s.31.22.63.22h.28c.31,0,.52-.07.62-.21s.15-.46.15-.97v-.13h.55Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m168.58,159.34v-5.19h.51v5.19h-.51Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.43,159.34v-4.68h-1.11v-.5h2.74v.5h-1.11v4.68h-.51Z",
    style: {
      fill: "#004876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.99,154.08c.47,0,.82.14,1.03.41s.32.72.32,1.35v1.8c0,.62-.11,1.07-.32,1.34s-.55.41-1.03.41h-.45c-.47,0-.82-.14-1.03-.41s-.32-.72-.32-1.34v-1.8c0-.62.11-1.07.32-1.35.21-.28.55-.41,1.03-.41h.45Zm-.07.51h-.31c-.33,0-.55.08-.68.25s-.18.5-.18,1v1.8c0,.5.06.83.18.99s.35.25.68.25h.31c.33,0,.55-.08.68-.25s.18-.5.18-.99v-1.8c0-.5-.06-.83-.18-1-.12-.17-.35-.25-.68-.25Z",
    style: {
      fill: "#004876"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFovime);
export default __webpack_public_path__ + "static/media/fovime.398c06a999deb1711d725d66b0692ed3.svg";
export { ForwardRef as ReactComponent };